import { render, staticRenderFns } from "./ProfileContact.vue?vue&type=template&id=c86ee770"
import script from "./ProfileContact.vue?vue&type=script&lang=js"
export * from "./ProfileContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports